import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames/bind';
import legacyEventHub, { cartItemsFromEvent } from '~/modules/legacyRuntime.js';
// import $ from 'jquery';
import ahoy from 'ahoy.js';
import confetti from 'canvas-confetti';
import { parseReactProps } from '~/components/legacy/reactProps.js';
import { trackCatalogEvent, withRankingPayload } from '~/modules/catalogEventTracking.js';
import { requestJson } from '~/modules/legacyRequest.js';

import UsageLicenseTypeSelect from '~/components/legacy/UsageLicenseTypeSelect.jsx';
import { buildProjectLicenseCartRequestData, buildProjectLicenseCartRemoveRequestData, buildProjectLicenseTrackingProps } from '~/components/legacy/projectLicenseCartSelection.js';

const MIN_DEMO_DOWNLOAD_LENGTH_SECONDS = 15;

class TrackInfo extends Component {

  // mixins: [UsageLicenseTypeSelectMixin, TrackFavoriteMixin],

  constructor(props) {
    super(props);

    this.handleLayoutDownloadClick = this.handleLayoutDownloadClick.bind(this);
    this.handleCartLinkClick = this.handleCartLinkClick.bind(this);
    this.updateProjectLicenseFamily = this.updateProjectLicenseFamily.bind(this);
    this.removeProjectLicenseSelection = this.removeProjectLicenseSelection.bind(this);
    this.triggerDemoDownload = this.triggerDemoDownload.bind(this);
    this.delegateFavoriteClick = this.delegateFavoriteClick.bind(this);
    this.handleShareClick = this.handleShareClick.bind(this);
    this.handleCartClick = this.handleCartClick.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.handleOpenUsageLicenseSelect = this.handleOpenUsageLicenseSelect.bind(this);
    this.handleToggleTrackFavorite = this.handleToggleTrackFavorite.bind(this);
    this.handleTriggerTrackDemoDownload = this.handleTriggerTrackDemoDownload.bind(this);
    this.handleTriggerTrackShare = this.handleTriggerTrackShare.bind(this);
    this.handleAudioPlayerPlay = this.handleAudioPlayerPlay.bind(this);
    this.shareTrack = this.shareTrack.bind(this);

    this.state = {
      data: this.props.data || '',
      displayCopyHint: false,
      shareTrackingFired: false,
      layoutDownloadTrackingFired: false,
      isVariant: false,
      trackVariantId: undefined,
      variantTitle: '',
      showUsageLicenseSelect: false,
      trackFavorites: this.props.trackFavorites
    }

    this.eventHubListeners = [];
  }

  componentDidMount() {
    this.registerEventHubListener('updateTrackInfo', function (data) {
      this.setState({ data: data[0], isVariant: false, variantTitle: '', trackVariantId: undefined })
    }.bind(this));

    this.registerEventHubListener('updateTrackVariantInfo', function (data) {
      this.setState({ data: data[0], isVariant: true, variantTitle: data[1].title, trackVariantId: data[1].id })
    }.bind(this));

    this.registerEventHubListener('updateCart', function (data) {
      this.setState({ cart_items: cartItemsFromEvent(data) });
    }.bind(this));

    this.registerEventHubListener('updateTrackFavorites', function (data) {
      this.setState({ trackFavorites: data[0] });
    }.bind(this));

    this.registerEventHubListener('audioPlayerPlay', this.handleAudioPlayerPlay);
    this.registerEventHubListener('openTrackUsageLicenseSelect', this.handleOpenUsageLicenseSelect);
    this.registerEventHubListener('toggleTrackFavorite', this.handleToggleTrackFavorite);
    this.registerEventHubListener('triggerTrackDemoDownload', this.handleTriggerTrackDemoDownload);
    this.registerEventHubListener('triggerTrackShare', this.handleTriggerTrackShare);
  }

  componentWillUnmount() {
    if (!legacyEventHub || typeof legacyEventHub.off !== 'function') {
      return;
    }

    this.eventHubListeners.forEach(function(listener) {
      legacyEventHub.off(listener.eventName, listener.handler);
    });
    this.eventHubListeners = [];
  }

  registerEventHubListener(eventName, handler) {
    legacyEventHub.on(eventName, handler);
    this.eventHubListeners.push({ eventName: eventName, handler: handler });
  }

  handleLayoutDownloadClick(e) {
    if (!this.demoDownloadAllowed()) {
      return;
    }

    this.triggerDemoDownload();

    if (typeof confetti !== 'undefined') {
      var rect = e.target.getBoundingClientRect();
      console.log(rect.top, rect.right, rect.bottom, rect.left);

      confetti({
        particleCount: 200,
        startVelocity: 30,
        angle: 90,
        spread: 60,
        shapes: ['circle'],
        origin: {
          x: (rect.left + 10) / window.innerWidth,
          // since they fall down, start a bit higher than random
          y: (rect.top + 20) / window.innerHeight
        },
        colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
      });
    }
  }

  handleCartLinkClick(e) {
    e.preventDefault();

    const trackId = this.state?.data?.id;

    if (!this.state.showUsageLicenseSelect && trackId) {
      trackCatalogEvent('track_open_license_select', { track_id: trackId, location: window.location.href });
    }

    this.setState({ showUsageLicenseSelect: !this.state.showUsageLicenseSelect });
  }

  handleOpenUsageLicenseSelect(args) {
    const payload = Array.isArray(args) ? args[0] : args;
    const requestedTrackId = payload && payload.trackId;
    const initialTrackId = this.props.data && this.props.data.id;
    const currentTrackId = this.state.data && this.state.data.id;

    if (typeof requestedTrackId === 'undefined' || requestedTrackId === null) {
      return;
    }

    if (String(requestedTrackId) !== String(currentTrackId) && String(requestedTrackId) !== String(initialTrackId)) {
      return;
    }

    this.setState({
      data: String(requestedTrackId) === String(initialTrackId) ? this.props.data : this.state.data,
      isVariant: false,
      variantTitle: '',
      trackVariantId: undefined,
      showUsageLicenseSelect: true
    });
  }

  handleToggleTrackFavorite(args) {
    const payload = Array.isArray(args) ? args[0] : args;
    const requestedTrackId = payload && payload.trackId;
    const initialTrackId = this.props.data && this.props.data.id;
    const currentTrackId = this.state.data && this.state.data.id;

    if (typeof requestedTrackId === 'undefined' || requestedTrackId === null) {
      return;
    }

    if (String(requestedTrackId) !== String(currentTrackId) && String(requestedTrackId) !== String(initialTrackId)) {
      return;
    }

    this.handleFavoriteClick(requestedTrackId);
  }

  handleTriggerTrackDemoDownload(args) {
    const payload = Array.isArray(args) ? args[0] : args;
    const requestedTrackId = payload && payload.trackId;
    const initialTrackId = this.props.data && this.props.data.id;
    const currentTrackId = this.state.data && this.state.data.id;

    if (typeof requestedTrackId === 'undefined' || requestedTrackId === null) {
      return;
    }

    if (String(requestedTrackId) !== String(currentTrackId) && String(requestedTrackId) !== String(initialTrackId)) {
      return;
    }

    this.triggerDemoDownload();
  }

  handleTriggerTrackShare(args) {
    const payload = Array.isArray(args) ? args[0] : args;
    const requestedTrackId = payload && payload.trackId;
    const initialTrackId = this.props.data && this.props.data.id;
    const currentTrackId = this.state.data && this.state.data.id;

    if (typeof requestedTrackId === 'undefined' || requestedTrackId === null) {
      return;
    }

    if (String(requestedTrackId) !== String(currentTrackId) && String(requestedTrackId) !== String(initialTrackId)) {
      return;
    }

    this.shareTrack();
  }

  handleAudioPlayerPlay(args) {
    const eventArgs = Array.isArray(args) ? args : [args];
    const trackData = eventArgs[0];

    if (!trackData || typeof trackData.id === 'undefined' || trackData.id === null) {
      return;
    }

    this.setState(function(previousState) {
      const sameTrack = String(previousState?.data?.id) === String(trackData.id);

      return {
        data: trackData,
        isVariant: sameTrack ? previousState.isVariant : false,
        variantTitle: sameTrack && previousState.isVariant ? previousState.variantTitle : '',
        trackVariantId: sameTrack && previousState.isVariant ? previousState.trackVariantId : undefined
      };
    });
  }

  triggerDemoDownload() {
    if (!this.demoDownloadAllowed()) {
      return;
    }

    var returnTo = encodeURIComponent((window.location.pathname || '/') + (window.location.search || ''));
    var customerSignedIn = (document.body?.getAttribute('data-user-tracking-context') || '').indexOf('customer') === 0;
    var link = document.createElement("a"),
      uri = '/c/tracks/' + this.state.data.id + '/download_layout?return_to=' + returnTo,
      isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
      isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    // If you don't know the name or want to use
    // the webserver default set name = ''

    if (this.state.isVariant && this.state.trackVariantId) {
      uri = '/tracks/' + this.state.data.id + '/download_layout_variant/' + this.state.trackVariantId + '?return_to=' + returnTo;
    }

    link.href = uri

    trackCatalogEvent('track_layout_download_intent', {
      track_id: this.state.data.id,
      track_variant_id: this.state.isVariant && this.state.trackVariantId ? this.state.trackVariantId : undefined,
      location: window.location.href
    });

    if (customerSignedIn) {
      // logged in
      if (!isChrome && !isFirefox) {
        link.setAttribute('download', '');
      }
    }

    if (customerSignedIn && !this.state.layoutDownloadTrackingFired) {
      trackCatalogEvent(this.props.freeMode ? 'track_layout_download_free' : 'track_layout_download', {
        track_id: this.state.data.id,
        location: window.location.href
      });
      this.setState({ layoutDownloadTrackingFired: true });
    }

    document.body.appendChild(link);

    link.click();
    link.remove();
  }

  demoDownloadAllowed() {
    return Number(this.state?.data?.length || 0) >= MIN_DEMO_DOWNLOAD_LENGTH_SECONDS;
  }


  delegateFavoriteClick(e) {
    e.preventDefault();

    this.handleFavoriteClick(this.state.data.id);

    if (!(this.trackIsFavorited(this.state.data.id, this.state.trackFavorites)) && typeof confetti !== 'undefined') {
      var rect = e.target.getBoundingClientRect();
      console.log(rect.top, rect.right, rect.bottom, rect.left);

      confetti({
        particleCount: 200,
        startVelocity: 30,
        angle: 90,
        spread: 60,
        shapes: ['circle'],
        origin: {
          x: (rect.left + 10) / window.innerWidth,
          // since they fall down, start a bit higher than random
          y: (rect.top + 20) / window.innerHeight
        },
        colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
      });
    }
  }

  shareTrack() {
    if (!this.state.shareTrackingFired) {
      trackCatalogEvent('track_share', { track_id: this.state.data.id, location: window.location.href });
    }

    if (navigator.share) {
      navigator.share({
        title: (this.state.data.display_title || this.state.data.title) + ' | ' + (this.props.locale === 'de' ? 'GEMAfreie Musik auf audiocrowd.net' : 'Royalty-free music on audiocrowd.net'),
        url: this.state.data.showcase_url + '?utm_source=share_link&utm_medium=referral'
      })
      this.setState({ shareTrackingFired: true });
      return;
    }

    this.copyToClipboard(this.state.data.showcase_url + '?utm_source=share_link&utm_medium=referral');
    this.setState({ displayCopyHint: true, shareTrackingFired: true }, function () {
      setTimeout(function () {
        this.setState({ displayCopyHint: false })
      }.bind(this), 5000)
    });
  }

  handleShareClick(e) {
    e.preventDefault();

    if (this.state.displayCopyHint) {
      this.setState({ displayCopyHint: false });
    } else {
      this.shareTrack();

      if (typeof confetti !== 'undefined') {
        var rect = e.target.getBoundingClientRect();
        console.log(rect.top, rect.right, rect.bottom, rect.left);

        confetti({
          particleCount: 200,
          startVelocity: 30,
          angle: 90,
          spread: 60,
          shapes: ['circle'],
          origin: {
            x: (rect.left + 10) / window.innerWidth,
            // since they fall down, start a bit higher than random
            y: (rect.top + 20) / window.innerHeight
          },
          colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
        });
      }
    }
  }


  copyToClipboard(str) {
    var el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  // handleClick: function(e) {
  //     var that = this;
  //     e.preventDefault();
  //     $.ajax({
  //         url: "/cart?track_id=" + this.state.data.id + (this.trackIsInCart(this.state.data.id, this.props.tracks_in_cart) ? '' : '&add=1'),
  //         type: 'POST'
  //     }).done(function(data) {
  //         legacyEventHub.trigger('updateCart', data)
  //     }.bind(this));
  // },

  // trackIsInCart : function(trackId, tracks) {
  //     var i,
  //         tracksLength = tracks && tracks.length ? tracks.length : 0;

  //     for (i = 0; i < tracksLength; i += 1) {
  //         if (tracks[i].track_id === trackId) {
  //             return true;
  //         }
  //     }
  //     return false;
  // },

  getUsageLicenseSelect() {
    var usageLicenseTypes = Array.isArray(this.props.usageLicenseTypes) ? this.props.usageLicenseTypes : [];
    var subscribedUsageLicenseTypes = Array.isArray(this.props.subscribedUsageLicenseTypes) ? this.props.subscribedUsageLicenseTypes : [];

    if (this.state.data.sound_effect_id) {
      usageLicenseTypes = usageLicenseTypes.filter(function (usageLicenseType) { return usageLicenseType.for_fx === true });
    } else {
      usageLicenseTypes = usageLicenseTypes.filter(function (usageLicenseType) { return usageLicenseType.for_fx === false });
    }

    return (
      <UsageLicenseTypeSelect
        locale={this.props.locale}
        addToCart={this.props.i18n.add_to_cart}
        discount={this.state.data.discount}
        subscribedUsageLicenseTypes={subscribedUsageLicenseTypes}
        usageLicenseTypes={usageLicenseTypes}
        updateCart={this.updateCart}
        selectionMode='project_license_family'
        updateProjectLicenseFamily={this.updateProjectLicenseFamily}
        removeProjectLicenseSelection={this.removeProjectLicenseSelection}
        pricing_path={this.props.pricing_path}
        selectedUsageLicenseTypeIds={this.getSelectedUsageLicenseTypeIds()}
        selectedProjectLicenseFamilyKeys={this.getSelectedProjectLicenseFamilyKeys()}
        selectedProjectLicenseSelections={this.getSelectedProjectLicenseSelections()}
        cartItems={this.state.cart_items || this.props.cart_items}
        i18n={this.props.i18n}
        visible={this.state.showUsageLicenseSelect}
        position={this.props.usageLicensePosition}
        handleCartClick={this.handleCartLinkClick}
        trackTitle={this.state.data.display_title || this.state.data.title}
        trackArtist={this.state.data.composer_name || this.state.data.composerName}
        trackImageMarkup={this.state.data.track_image_markup} />
    )
  }

  updateCart(usageLicenseTypeId, exposurePackId, forFx) {
    var itemId = this.props.id || this.state.data.id,
      i,
      updateUrl;

    if (exposurePackId) {
      updateUrl = "/cart?exposure_pack_id=" + exposurePackId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else if (forFx) {
      updateUrl = "/cart?sound_effect_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else {
      updateUrl = "/cart?track_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    }

    return requestJson(updateUrl, {
      method: 'POST',
      data: this.cartRequestContext()
    }).then(function (data) {

      legacyEventHub.trigger('updateCart', data)

      var cartItems = data.items || data;
      if (!Array.isArray(cartItems)) {
        cartItems = [];
      }

      // One click should emit one add_cart event, even if cartItems has duplicates.
      for (i = 0; i < cartItems.length; i += 1) {
        if (cartItems[i].track_id === itemId) {
          trackCatalogEvent('track_add_cart', { track_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href });
          break;
        } else if (cartItems[i].sound_effect_id === itemId) {
          trackCatalogEvent('sound_effect_add_cart', { sound_effect_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href });
          break;
        }
      }

      if (typeof fbq === 'function') {
        fbq('track', 'AddToWishlist', {
          content_ids: itemId.toString(),
          content_type: 'product',
        });
      }

    }.bind(this));
  }

  updateProjectLicenseFamily(projectLicenseSelection) {
    var itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRequestData(itemId, projectLicenseSelection, this.cartRequestContext());
    const trackingProps = buildProjectLicenseTrackingProps(itemId, projectLicenseSelection, window.location.href);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: requestData
    }).then(function (data) {
      legacyEventHub.trigger('updateCart', data)

      trackCatalogEvent('track_add_cart', trackingProps)
    }.bind(this));
  }

  removeProjectLicenseSelection(projectLicenseSelection) {
    var itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRemoveRequestData(itemId, projectLicenseSelection);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: requestData
    }).then(function (data) {
      legacyEventHub.trigger('updateCart', data)
    }.bind(this));
  }

  handleCartClick(e) {
    e.preventDefault();
    this.props.handleCartClick(this.props.id);
  }

  getSelectedUsageLicenseTypeIds() {
    var ids = [],
      that = this,
      trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

    if (!Array.isArray(cart_items)) {
      return ids;
    }

    cart_items.forEach(function (element) {
      if (element.track_id === trackId) {
        ids.push(element.usage_license_type_id);
      }
    });

    return ids;
  }

  getSelectedProjectLicenseFamilyKeys() {
    var familyKeys = [],
      that = this,
      trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

    if (!Array.isArray(cart_items)) {
      return familyKeys;
    }

    cart_items.forEach(function (element) {
      if (element.track_id === trackId && element.project_license_family_key) {
        familyKeys.push(element.project_license_family_key);
      }
    });

    return familyKeys;
  }

  getSelectedProjectLicenseSelections() {
    var selections = [],
      that = this,
      trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

    if (!Array.isArray(cart_items)) {
      return selections;
    }

    cart_items.forEach(function (element) {
      if (element.track_id === trackId && element.project_license_family_key) {
        selections.push({
          familyKey: element.project_license_family_key,
          usageLicenseTypeId: element.usage_license_type_id,
          selectedOptionKeys: element.project_license_option_keys,
          customerProjectLicensePresetId: element.customer_project_license_preset_id,
          customerEventLicensePresetId: element.customer_event_license_preset_id,
          projectLicensePresetName: element.project_license_preset_name
        });
      }
    });

    return selections;
  }

  handleFavoriteClick(trackId) {
    return requestJson("/track_favorite?track_id=" + trackId, {
      method: 'POST',
      data: {}
    }).then(function (data) {

      if (!(this.trackIsFavorited(trackId, this.state.trackFavorites))) {
        legacyEventHub.trigger('trackFavorited', trackId);
      }

      legacyEventHub.trigger('updateTrackFavorites', data)
    }.bind(this));
  }

  trackIsFavorited(trackId, favorites) {
    var i,
      favoritesLength = favorites && favorites.length ? favorites.length : 0;

    for (i = 0; i < favoritesLength; i += 1) {
      if (favorites[i].track_id === trackId) {
        return true;
      }
    }
    return false;
  }

  cartRequestContext() {
    return withRankingPayload({ location: window.location.href }, this.state.data || this.props.data || this.props);
  }

  render() {
    var classes = classNames({
      'track-info': true,
      'track-info--hide-cart': this.props.hide_add_to_cart
    }),
      loop,
      variableTempo,
      cartLink,
      toCheckoutLink,
      instruments,
      genres,
      moods,
      tags,
      trackTitle,
      layoutDownloadLink,
      showcaseLink,
      favoriteLink,
      showCaseLink,
      copyHint,
      price,
      shareLink;

    // if (this.props.usageLicenseTypes.length > 0) {
    //     price = <span className='track-info__price'>ab {this.props.usageLicenseTypes[0].formatted_gross_price_eur}</span>;

    //     if (this.state.data.discount) {
    //        price = <span className='track-info__price'>ab {this.props.usageLicenseTypes[0].formatted_discount_gross_price_eur}</span>;
    //     }

    //     if (this.state.data.free) {
    //       price = <span className='track-info__price'>{this.props.i18n.free}</span>;
    //     }
    // }

    if (this.state.data) {
      if (this.state.data.instruments) {
        instruments = this.state.data.instruments.map(function (instrument, index) {
          return (
            <span className="track-info__label track-info__label-label track-info__label-instrument">{instrument}</span>
          );
        });
      }

      if (this.state.data.moods) {
        moods = this.state.data.moods.map(function (mood, index) {
          return (
            <span className="track-info__label track-info__label-label track-info__label-mood">{mood}</span>
          );
        });
      }

      if (this.state.data.tags) {
        tags = this.state.data.tags.map(function (tag, index) {
          return (
            <span className="track-info__label track-info__label-label track-info__label-tag">{tag}</span>
          );
        });
      }

      if (this.state.data.genres) {
        genres = this.state.data.genres.map(function (genre, index) {
          return (
            <span className="track-info__label track-info__label-label track-info__label-genre">{genre}</span>
          );
        });
      }

      if (this.state.data.loop) {
        loop = <span className="track-info__label track-info__label-label track-info__label-loop">Loop</span>
      }

      if (this.state.displayCopyHint && !navigator.share) {
        copyHint = <div className="track-info__copy-hint">
          <i className='track-info__copy-hint-icon fa fa-check'></i>
          <span className='track-info__copy-hint-text'>{this.props.locale === 'de' ? 'Die Track-URL wurde in die Zwischenablage kopiert.' : 'The track URL was copied to your clipboard.'}</span>
        </div>;
      }


      if (this.state.data.variableTempo) {
        variableTempo = <span className="track-info__label track-info__label-label track-info__label-variable-tempo">altering Tempo</span>
      }

      trackTitle = <a className='track-info__title-link' href={this.state.data.showcase_url} title={this.state.data.display_title || this.state.data.title} target='_blank'>{this.state.data.display_title || this.state.data.title}{this.state.isVariant && this.state.variantTitle.length > 0 ? (' (' + this.state.variantTitle + ')') : ''}</a>;

      if (this.props.show_meta && !this.props.hideActions) {
        if (!this.props.freeMode) {
          cartLink = <a className="track-info__cart-link track-info__cart-link-add" href="#" onClick={this.handleCartLinkClick}><span className='track-info__cart-link-icons'><i className="fa fa-plus"></i><i className="fa fa-shopping-cart"></i></span></a>
        }

        if (this.demoDownloadAllowed()) {
          layoutDownloadLink = (<a className="track-info__download-link" onClick={this.handleLayoutDownloadClick} title={this.props.i18n.layout_download}>
            <div className='tooltip'>
              <i className='fa fa-download'></i>
              <span className='track-info__download-link-label'>{this.props.i18n.layout_download}</span>
              <div className='tooltip__content'>{this.props.locale === 'de' ? 'DEMO-Download: Testen Sie den Track vor dem Kauf. Für den Download benötigen Sie ein kostenloses Kundenkonto.' : 'Demo download: Test the track before purchase. A free customer account is required for the download.'}</div>
            </div>
          </a>);
        } else {
          layoutDownloadLink = (<span className="track-info__download-link track-info__download-link--disabled" title={this.props.i18n.layout_download} aria-disabled="true">
            <div className='tooltip'>
              <i className='fa fa-download'></i>
              <span className='track-info__download-link-label'>{this.props.i18n.layout_download}</span>
            </div>
          </span>);
        }
      }

      if (!this.props.hideActions) {
        if (this.trackIsFavorited(this.state.data.id, this.state.trackFavorites)) {
          favoriteLink = <a className='track-info__favorite-link track-info__favorite-link--favorited' onClick={this.delegateFavoriteClick}><i className='fa fa-heart'></i><span className='track-info__favorite-link-label'>{this.props.locale === 'de' ? 'gemerkt' : 'remembered'}</span></a>;
        } else {
          favoriteLink = <a className='track-info__favorite-link' onClick={this.delegateFavoriteClick}><i className='fa fa-heart-o'></i><span className='track-info__favorite-link-label'>{this.props.locale === 'de' ? 'merken' : 'remember'}</span></a>;
        }

        shareLink = (
          <div className="track-info__showcase-link" title={this.state.data.title} onClick={this.handleShareClick}>
            {copyHint}
            <i className="fa fa-share-alt"></i>
            <span className='track-info__showcase-link-label'>{this.props.locale === 'de' ? 'Teilen' : 'Share'}</span>
          </div>
        );
      }


      return (
        <div className={classes}>
          <span className='track-info__title'>
            <span className='track-info__id'>
              {this.state.data.id}
            </span>
            {trackTitle}
          </span>
          {favoriteLink}
          {layoutDownloadLink}
          {cartLink}
          {shareLink}
          {this.getUsageLicenseSelect()}
        </div>
      );
    } else {
      return (<div></div>);
    }
  }
}

TrackInfo.defaultProps = {
  data: {
    tracks_in_cart: [],
    is_in_cart: false,
    instruments: [],
    moods: [],
    genres: [],
    tags: [],
    showcase_url: ''
  },
  i18n: {
    add_to_cart: 'add to cart',
    checkout_now: 'checkout now',
    layout_download: 'layout download'
  },
  checkout_path: 'c/checkouts/new',
  open_in_new_tab: 'open in new tab',
  show_meta: true,
  usageLicensePosition: 'overlay',
  freeMode: false,
  subscribedUsageLicenseTypes: [],
  usageLicenseTypes: [],
  hideActions: false,
  cart_items: [],
  trackFavorites: []
}



// INIT

let elements = document.querySelectorAll('[data-react-component=TrackInfo]');

elements.forEach(function (element) {
  try {
    let reactProps = parseReactProps(element.dataset.reactProps);

    ReactDOM.render(
      <React.StrictMode>
        <TrackInfo {...reactProps} />
      </React.StrictMode>,
      element
    );
  } catch (error) {
    console.error('Failed to mount TrackInfo', error);
  }
})

export default TrackInfo;
